// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer_cyXAz","page":"page_zJuHT","scroll":"scroll_2GPab","scroll_bar":"scroll_bar_PPVxd","scroll_next":"scroll_next_FWEiK","scroll_prev":"scroll_prev_+wVr5"};